import React, { createContext, useContext, useState, useEffect } from 'react';
import api from './api';

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem('token');
    const userData = localStorage.getItem('user');
    if (token && userData) {
      try {
        setUser(JSON.parse(userData));
      } catch (e) {
        localStorage.removeItem('token');
        localStorage.removeItem('user');
      }
    }
    setLoading(false);
  }, []);

  const login = async (username, password) => {
    const response = await api.post('/token', { username, password });
    const { access_token } = response.data;
    
    // Decode JWT to get user info
    const payload = JSON.parse(atob(access_token.split('.')[1]));
    const userData = {
      id: parseInt(payload.sub),
      username: payload.username,
      role: payload.role,
    };

    localStorage.setItem('token', access_token);
    localStorage.setItem('user', JSON.stringify(userData));
    setUser(userData);
    return userData;
  };

  const logout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    setUser(null);
  };

  const hasRole = (roles) => {
    return user && roles.includes(user.role);
  };

  const hasAccessToObjects = async () => {
    if (!user || user.role === 'admin') return [];
    
    try {
      const response = await api.get('/objects?per_page=100');
      return response.data.items;
    } catch (error) {
      console.error('Error fetching objects:', error);
      return [];
    }
  };

  return (
    <AuthContext.Provider value={{ user, login, logout, hasRole, hasAccessToObjects, loading }}>
      {!loading && children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within AuthProvider');
  }
  return context;
};
